import { useState, useRef, useEffect } from 'react';
import { resolveIssueTypeConfig } from '../../../constants/issueTypeConfig';
import { ROW_HEIGHT } from './timelineUtils';

interface Props {
  issueType: string;
  depth: number;
  onSubmit: (title: string) => void;
  onCancel: () => void;
}

export default function InlineIssueCreate({ issueType, depth, onSubmit, onCancel }: Props) {
  const [title, setTitle] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);
  const submittedRef = useRef(false);

  const config = resolveIssueTypeConfig(undefined, issueType);
  const { Icon, color, hexColor, label } = config;

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.nativeEvent.isComposing) return;
    if (e.key === 'Enter' && title.trim() && !submittedRef.current) {
      submittedRef.current = true;
      onSubmit(title.trim());
    } else if (e.key === 'Escape') {
      onCancel();
    }
  };

  const handleBlur = () => {
    if (!submittedRef.current) {
      onCancel();
    }
  };

  return (
    <div
      className="flex items-center gap-1.5 pr-2 bg-blue-50 border-b border-blue-100"
      style={{ paddingLeft: `${depth * 20 + 8 + 20}px`, height: `${ROW_HEIGHT}px` }}
    >
      <Icon size={14} className={`flex-shrink-0 ${color}`} style={hexColor ? { color: hexColor } : undefined} />
      <input
        ref={inputRef}
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        onKeyDown={handleKeyDown}
        onBlur={handleBlur}
        placeholder={`${label} 제목 입력 (Enter: 생성, Esc: 취소)`}
        className="flex-1 text-sm bg-transparent border-none outline-none placeholder-gray-400"
      />
    </div>
  );
}
